import { render } from "./AlzataCreateAccount.vue?vue&type=template&id=134f6641"
import script from "./AlzataCreateAccount.vue?vue&type=script&lang=js"
export * from "./AlzataCreateAccount.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__